import i18n from "i18next";
import {initReactI18next} from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            "common.log out": "Log out",
            "common.welcome": "Welcome",

            "header.call center 1240, press 4": "Call center 1240, press 4",
            "header.back to home page": "Back to home page",

            "calendar.from": "from",
            "calendar.to": "to",

            "kyc-profile.title": "KYC Upload Status",
            "kyc-profile.search branch id": "Branch ID",
            "kyc-profile.search transaction date": "Transaction Date",
            "kyc-profile.search upload date": "Upload Date",
            "kyc-profile.search identity": "ID Card/Passport No",
            "kyc-profile.search work permit id": "Work Permit No",
            "kyc-profile.search customer name": "Customer Name",
            "kyc-profile.search document status": "Document Status",
            "kyc-profile.search kyc level": "KYC Level",
            "kyc-profile.search point of transaction": "Point of Transaction"
        }
    },
    th: {
        translation: {
            "common.log out": "Log out",
            "common.welcome": "Welcome",

            "header.call center 1240, press 4": "Call center 1240, press 4",
            "header.back to home page": "Back to home page",

            "calendar.from": "from",
            "calendar.to": "to",

            "kyc-profile.title": "KYC Upload Status",
            "kyc-profile.search branch id": "Branch ID",
            "kyc-profile.search transaction date": "Transaction Date",
            "kyc-profile.search upload date": "Upload Date",
            "kyc-profile.search identity": "ID Card/Passport No",
            "kyc-profile.search work permit id": "Work Permit No",
            "kyc-profile.search customer name": "Customer Name",
            "kyc-profile.search document status": "Document Status",
            "kyc-profile.search kyc level": "KYC Level",
            "kyc-profile.search point of transaction": "Point of Transaction"
        }
    }
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
        .init({
        resources,
        lng: "en",
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // React already does escaping
        }
});
